import { InjectionToken } from '@angular/core';
import { StoreConfig } from '@ngrx/store';

import { BasketState } from './store';

export const BASKET_STORAGE_KEYS = new InjectionToken<keyof BasketState>(
  'BasketStorageKeys',
);
export const BASKET_STORAGE_KEY = new InjectionToken<string[]>('BasketStorage');
export const BASKET_CONFIG_TOKEN = new InjectionToken<StoreConfig<BasketState>>(
  'BasketConfigToken',
);
